module.exports = __webpack_public_path__ + "img/compliance.675207a3.png";